export class JwtHelper {
  private static urlBase64Decode(str: string) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch (output.length % 4) {
      case 0:
        break;
      case 2:
        output += "==";
        break;
      case 3:
        output += "=";
        break;
      default:
        throw new Error("Illegal base64url string!");
    }
    return decodeURIComponent((window as any).escape(window.atob(output)));
  }

  public decodeToken(token: string = "") {
    if (token === null || token === "") {
      return { upn: "" };
    }
    const parts = token.split(".");
    if (parts.length !== 3) {
      throw new Error("JWT must have 3 parts");
    }
    const decoded = JwtHelper.urlBase64Decode(parts[1]);
    if (!decoded) {
      throw new Error("Cannot decode the token");
    }
    return JSON.parse(decoded);
  }

  public isTokenAlive(token: string = "") {
    if (token === null || token === "") {
      return false;
    }
    const decodeToken = this.decodeToken(token);
    const now = new Date().getTime() / 1000;
    return now < decodeToken.exp;
  }
}
